import { makeAutoObservable } from 'mobx';

export interface PositionArgs {
	id: number;
	name: string;
}

export class Position {
	private _id: number;
	private _name: string;

	constructor(args: PositionArgs) {
		makeAutoObservable(this);

		this._id = args.id;
		this._name = args.name;
	}

	// getters

	get id() {
		return this._id;
	}
	get name() {
		return this._name;
	}

	// getters end
}
